module.exports = __webpack_public_path__ + "static/media/neutral.271d2caa.jpg";